type VimeoPlayerErrorAttributes = Readonly<{
  vimeoErrorName?: string;
  vimeoErrorMessage?: string;
  vimeoErrorMethod?: string;
}>;

type VimeoPlayerErrorReport = Readonly<{
  error: Error;
  attributes: VimeoPlayerErrorAttributes;
}>;

const nonEmptyString = (value: unknown): string | undefined => (typeof value === 'string' && value.trim() ? value : undefined);

// Vimeo's error event sends a plain object, which addError would report as `Error: unknown`.
export const toVimeoPlayerErrorReport = (payload: unknown): VimeoPlayerErrorReport => {
  const fields: Partial<Record<'name' | 'message' | 'method', unknown>> = payload !== null && typeof payload === 'object' ? payload : {};
  const name = nonEmptyString(fields.name);
  const message = nonEmptyString(fields.message) ?? nonEmptyString(payload);
  const method = nonEmptyString(fields.method);

  const detail = [name, message].filter(Boolean).join(': ') || `no details (payload: ${payload === null ? 'null' : typeof payload})`;
  const error = new Error(`Vimeo player error: ${detail}`);
  if (name) error.name = name;
  if (payload instanceof Error && payload.stack) error.stack = payload.stack;

  const attributes: VimeoPlayerErrorAttributes = {
    ...(name && { vimeoErrorName: name }),
    ...(message && { vimeoErrorMessage: message }),
    ...(method && { vimeoErrorMethod: method }),
  };

  return { error, attributes };
};
